import { render, staticRenderFns } from "./NodeEditor.vue?vue&type=template&id=65fe0bb8"
import script from "./NodeEditor.vue?vue&type=script&lang=js"
export * from "./NodeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports